import service from '@/store/services/boletos-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  boleto: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, boleto) => {
    state.boleto = boleto;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  getInfo({commit, dispatch}, params) {
    return service.getInfo(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  verificacion({commit, dispatch}, params) {
    return service.verificacion(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  autorizacion({commit, dispatch}, params) {
    return service.autorizacion(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  autorizacionToken({commit, dispatch}, params) {
    return service.autorizacionToken(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  anulaBoleto({commit, dispatch}, params) {
    return service.anulaBoleto(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  reimprimeBoleto({commit, dispatch}, params) {
    return service.reimprimeBoleto(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  cambiaNombrePasajeroBoleto({commit, dispatch}, params) {
    return service.cambiaNombrePasajeroBoleto(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  veReserva({commit, dispatch}, params) {
    return service.veReserva(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  confirmaReserva({commit, dispatch}, params) {
    return service.confirmaReserva(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  anulaReserva({commit, dispatch}, params) {
    return service.anulaReserva(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  vendeEquipajeExtra({commit, dispatch}, params) {
    return service.vendeEquipajeExtra(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  reimprimeBoleto({commit, dispatch}, params) {
    return service.reimprimeBoleto(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  crearToken({commit, dispatch}, params) {
    return service.crearToken(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  canjeBoleto({commit, dispatch}, params) {
    return service.canjeBoleto(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  getboletosParaAnular({commit, dispatch}, params) {
    return service.getboletosParaAnular(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  getInfo: state => state.boleto,
  getboletosParaAnular: state => state.boleto,
  boleto: state => state.boleto,
  verificacion: state => state.boleto,
  autorizacion: state => state.boleto,
  autorizacionToken: state => state.boleto,
  anulaBoleto: state => state.boleto,
  reimprimeBoleto: state => state.boleto,
  cambiaNombrePasajeroBoleto: state => state.boleto,
  veReserva: state => state.boleto,
  confirmaReserva: state => state.boleto,
  anulaReserva: state => state.boleto,
  vendeEquipajeExtra: state => state.boleto,
  crearToken: state => state.boleto,
  canjeBoleto: state => state.boleto,
  url: state => state.url
};

const boletos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default boletos;
